import { useTranslation } from 'react-i18next';
import { LOCALES, NATIVE_NAME, type Locale, setLocale } from '@/i18n';
import { REGION_TAG } from '@marcianus/shared/i18n-core';
import { setLocalePreference } from '@/api/admin';

/** Seletor de idioma da consola HQ — nomes nativos, acessível, sem recarregar. */
export function LanguageSwitcher() {
  const { t, i18n } = useTranslation();
  const change = async (next: Locale) => {
    await setLocale(next);
    void setLocalePreference(next).catch(() => {});   // viaja com a conta
  };
  return (
    <label style={{ display: 'inline-flex', alignItems: 'center' }}>
      <span className="sr-only">{t('language.label')}</span>
      <select value={i18n.language} aria-label={t('language.choose')} className="input"
        style={{ minHeight: 40, maxWidth: 130, padding: '0 8px', fontSize: 14 }}
        onChange={(e) => void change(e.target.value as Locale)}>
        {LOCALES.map((l) => <option key={l} value={l} lang={REGION_TAG[l]}>{NATIVE_NAME[l]}</option>)}
      </select>
    </label>
  );
}
